import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stepper as MuiStepper, Stack, Step, StepConnector, stepConnectorClasses, StepLabel, styled, } from '@mui/material';
import React, { useMemo } from 'react';
import { WizardContext } from './WizardContext';
var StyledConnector = styled(StepConnector)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b["&.".concat(stepConnectorClasses.alternativeLabel)] = {
            top: 10,
            left: 'calc(-50% + 16px)',
            right: 'calc(50% + 16px)',
        },
        _b["& .".concat(stepConnectorClasses.line)] = {
            borderColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#eaeaf0',
            borderTopWidth: 3,
            borderRadius: 1,
        },
        _b["&.".concat(stepConnectorClasses.active, " .").concat(stepConnectorClasses.line, ", &.").concat(stepConnectorClasses.completed, " .").concat(stepConnectorClasses.line)] = {
            borderColor: '#2E7D32',
        },
        _b);
});
export var Wizard = function (_a) {
    var currentStep = _a.currentStep, onStepChange = _a.onStepChange, children = _a.children;
    var steps = useMemo(function () {
        return React.Children.toArray(children).filter(function (step) {
            var _a;
            return React.isValidElement(step) &&
                ((_a = step.props.visible) !== null && _a !== void 0 ? _a : true);
        });
    }, [children]);
    var stepKeys = steps.map(function (step) { return step.props.stepKey; });
    var currentStepIndex = stepKeys.indexOf(currentStep);
    var contextValue = {
        currentStep: currentStep,
        nextStep: function () {
            var nextIndex = currentStepIndex + 1;
            if (nextIndex < steps.length) {
                onStepChange(stepKeys[nextIndex]);
            }
        },
        prevStep: function () {
            var prevIndex = currentStepIndex - 1;
            if (prevIndex >= 0) {
                onStepChange(stepKeys[prevIndex]);
            }
        },
        isFirstStep: currentStepIndex === 0,
        isLastStep: currentStepIndex === steps.length - 1,
    };
    return (_jsxs(WizardContext.Provider, { value: contextValue, children: [_jsx(Stack, { id: "stepper-container", sx: {
                    maxWidth: '100%',
                    backgroundColor: '#FFFFFF',
                    overflow: 'hidden',
                }, paddingX: { xs: '1rem' }, paddingY: "1.75rem", justifyContent: "center", alignItems: { md: 'center' }, minHeight: { xs: '4rem', md: 'auto' }, children: _jsx(MuiStepper, { activeStep: currentStepIndex, alternativeLabel: true, connector: _jsx(StyledConnector, {}), children: steps.map(function (step) { return (_jsx(Step, { children: _jsx(StepLabel, { children: step.props.title }) }, step.props.stepKey)); }) }) }), _jsx(Box, { mt: 2, children: steps[currentStepIndex] })] }));
};
